import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  AutoSizer,
} from 'react-virtualized'

import Container from './ColumnGridContainer'
import BodyGrid from './BodyGrid'
import HeaderGrid from './HeaderGrid'

const ColumnGridContainer = props => {
  const {
    cellRenderer,
    headerCellRenderer,
    ...rest
  } = props
  return (
    <AutoSizer disableHeight>
      {({width}) => (
        <Container>
          <HeaderGrid
            {...rest}
            width={width}
            cellRenderer={headerCellRenderer}
          />
          <BodyGrid
            {...rest}
            width={width}
            cellRenderer={cellRenderer}
          />
        </Container>
      )}
    </AutoSizer>
  )
}

export default ColumnGridContainer
